import { LineChart } from "echarts/charts";
import { GridComponent, TitleComponent, TooltipComponent } from "echarts/components";
import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import ReactEChartsCore from "echarts-for-react/lib/core";

import { useInfo } from "@/context/InfoProvider/InfoProvider";
import { colors, toCompactNumber } from "@/Utils";
import { getHoverTooltip } from "@/Utils/ECharts/HoverTooltip";
import { extraCssText } from "@/Utils/extraCssText";

echarts.use([TitleComponent, TooltipComponent, GridComponent, LineChart, CanvasRenderer]);

const BasicMultipleLineGraph = ({
  hoverData = {
    componentName: "",
    data: {},
  },
  legendLabel,
  xAxisData,
  seriesData,
}) => {
  const { theme } = useInfo();

  const options = {
    grid: {
      left: "1%",
      right: "0%",
      top: "4%",
      bottom: "12%",
      containLabel: true,
    },
    textStyle: {
      color: theme.color,
      fontFamily: "Montserrat",
    },
    tooltip: {
      borderColor: "transparent",
      textStyle: {
        color: colors.white,
      },
      formatter: (params) => {
        return getHoverTooltip({
          params,
          data: hoverData.data,
          componentName: hoverData.componentName,
        });
      },
      backgroundColor: colors.cardBg,
      extraCssText: extraCssText,
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      textStyle: {
        color: theme.color,
      },
      data: legendLabel,
      icon: "circle",
      y: "bottom",
      x: "left",
      left: "3%",
    },
    xAxis: [
      {
        axisLabel: {
          fontSize: 10,
        },
        data: xAxisData,
        silent: false,
        splitLine: {
          show: false,
        },
        splitArea: {
          show: false,
        },
        type: "category",
        boundaryGap: true,
        offset: 5,
        axisTick: {
          alignWithLabel: true,
        },
      },
    ],
    yAxis: {
      nameTextStyle: {
        fontSize: 10,
      },
      type: "value",
      axisLabel: {
        fontSize: 10,
        formatter: (value) => {
          return toCompactNumber(value);
        },
      },
      splitLine: {
        lineStyle: {
          color: colors.lightGray,
        },
      },
    },
    series: seriesData,
  };
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={options}
      notMerge={true}
      lazyUpdate={true}
      style={{
        height: "360px",
      }}
    />
  );
};

export default BasicMultipleLineGraph;
